export default __webpack_public_path__ + "static/media/total_budget.f0d113de.svg";